import React from "react";
import CartItem from "../Components/CartItem";
import {
    addItem,
    deleteChangedItem,
    deleteItem,
    setAllItem,
    setChangedItem,
} from "../store/actions/cart_actions";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {Checkboxes} from "./CatalogPage";

export function getCartData(array){
    let positions = 0;
    let bonus = 0;
    let price = 0;
    if (array !== undefined && array.length > 0){
        array.forEach(item => {
            item.services.forEach(el => {
                positions += el.count;
                price += el.count * el.price;
            });
            bonus += item.refund;
        })
    }
    return {positions: positions, price: price, bonus: bonus}

}

export const ResultInfo = (items, positions, price, bonus) => {
    return(
        <div>
            <div className={'cart_result_info'}>
                <div className={'result_title'}>
                    <p>Итого:</p>
                </div>
                <div className={'result_line'}/>
                <div className={'result_position'}>
                    <p>Позиций:</p>
                    <p>{items}</p>
                </div>
                <div className={'result_position'}>
                    <p>Услуг в заявке:</p>
                    <p>{positions}</p>
                </div>
                <div className={'result_position'}>
                    <p>На сумму:</p>
                    <p>{price.toFixed(2)} руб.</p>
                </div>
                <div className={'result_position'}>
                    <p>Включая НДС:</p>
                    <p>{(price * 0.2).toFixed(2)} руб.</p>
                </div>
            </div>
            <div className={'cart_result_info'}>
                <div className={'result_position'}>
                    <p>Возврат:</p>
                    <p>{bonus}</p>
                </div>
                <div className={'result_position'}>
                    <p>Бонусы:</p>
                    <p>{bonus * 100}</p>
                </div>
            </div>
        </div>
    )
};

class CartPage extends React.Component{
    constructor(props) {
        super(props);
        let items = localStorage.getItem('cart');
        if (items !== null && items.length > 0) {
            items.split(';').forEach(item => {
            if (item !== '') {
                try {
                    let data = JSON.parse(item);
                    this.props.addItem(data);
                }catch (e) {

                }
            }
        })
        }
        this.state ={
            all_selected: false,
        }
    }

    OrderCartField = (data) =>{
        return(
            <div id={'order_cart_field'} className={'order_cart_field'}>
                <div>
                    <div className={'description'}>
                        <p>{data.price.toFixed(2)} ₽</p>
                        <p>{data.position} товаров</p>
                    </div>
                    <div>
                        <Link to={'/order_create'}>
                            <button>
                                <p>Оформить заказ</p>
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        )
    };



    componentDidMount(): void {
        let block = document.getElementById('order_cart_field');
        block.style.display = 'none';
        window.addEventListener('scroll', Ascroll, false);
        function Ascroll() {
            if (document.body.offsetHeight - document.documentElement.clientWidth- 720 < document.documentElement.scrollTop) {
                block.style.display = 'none'
            }
            else
                block.style.display = 'block'
        }
    }

    render() {
        const {cart} = this.props;
        let data = getCartData(cart.cart_items);
        return(
            <main id={'cart_page'}>
                <div>
                    <div className={"title_container"}>
                        <p>Корзина</p>
                    </div>
                    {this.OrderCartField({price:data.price,position:cart.cart_items.length})}
                    <div>
                    <div id={'cart_list'}>
                        <div className={'cart_select_position'}>
                            <button onClick={() => {
                                this.setState({all_selected: !this.state.all_selected});
                                this.props.setAllItem(!this.state.all_selected)}}>
                                {Checkboxes(this.state.all_selected)}
                                <p>Выбрать все</p>
                            </button>
                            {cart.chooses_items.length === 0 ? undefined : (
                                <button onClick={() => {
                                    this.props.deleteChangedItem()
                                }}>
                                    <p>Удалить выбранные</p>
                                </button>
                            ) }
                        </div>
                        <div className={'desktop_cart_table'}>
                            <div>Название</div>
                            <div>Цена за ед. ₽</div>
                            <div>Услуг в заявке</div>
                            <div>Цена ₽</div>
                        </div>
                        <div id={'items'}>
                            {cart.cart_items.map( item => {
                                return (<CartItem item={item} key={item.id}/>)
                            })}
                        </div>
                    </div>
                    <div id={'cart_result'}>
                        {ResultInfo(cart.cart_items.length, data.positions, data.price, data.bonus)}
                        {cart.cart_items.length > 0? (
                            <div>
                                <Link to={'/order_create'}>
                                    <button className={'order_button'}>
                                        <p>Перейти к оформлению</p>
                                    </button>
                                </Link>
                            </div>
                        ): undefined}

                        <div className={'result_add_position'}>
                            <Link to={'/catalog'}>
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.4991 12.4991C19.0163 5.98191 29.5522 5.98191 36.0694 12.4991C42.5865 19.0162 42.5865 29.5521 36.0694 36.0693C29.5522 42.5865 19.0163 42.5865 12.4991 36.0693C5.98198 29.5521 5.98198 19.0162 12.4991 12.4991ZM22.6226 14.1608V22.6225H14.1608V25.9459H22.6226V34.4076H25.946V25.9459H34.4077V22.6225H25.946V14.1608H22.6226Z" fill="#86C3EE"/>
                                </svg>
                            </Link>
                            <Link to={'/catalog'}>
                                <p>Добавить позицию</p>
                            </Link>
                        </div>
                    </div>
                    </div>
                </div>
            </main>
        )
    }
}

const mapStateToProps = store => {
    return{
        cart: store.cart,
    }
};

const mapDispatchToProps = dispatch => {
    return{
        setChangedItem: (id, flag) => dispatch(setChangedItem(id, flag)),
        deleteItem: (id) => dispatch(deleteItem(id)),
        addItem: (id) => dispatch(addItem(id)),
        deleteChangedItem: () => dispatch(deleteChangedItem()),
        setAllItem: (flag) => dispatch(setAllItem(flag)),
    }
};




export default connect(mapStateToProps,mapDispatchToProps)(CartPage)
